const PREFIX = 'PROFILE_PASSWORD_FORM_';
export const FORM_RESET = `${PREFIX}RESET`;
export const reset = () => ({
  type: FORM_RESET
});